import { createPortal } from 'react-dom'
import useHasMounted from '@/hooks/useHasMounted'
import { WithChildren } from '@/types/utilities'

export default function Overlay({ children }: WithChildren<{}>) {
  const hasMounted = useHasMounted()

  /**
   * we are not locking the scroll because
   * https://aykevl.nl/2014/09/fix-jumping-scrollbar
   *
   * see the attempt in globals.css
   *
   */

  if (!hasMounted) {
    return null
  }

  const overlayRootEl = document.getElementById('overlay-root')

  if (!overlayRootEl) {
    return null
  }

  return createPortal(children, overlayRootEl)
}
